import { useCallback, useContext, useMemo } from "react";
import { AuthorizationContext } from "./context";
import { checkRequiredPermissions } from "./utils";

export function useGetCheckAccessFunction(): (requiredPermissions?: string | string[], requiredOneOfPermissions?: string | string[]) => {
  pending: boolean,
  isAccessAllowed: boolean
} {
  const { isSuperAdmin, permissions, isAuthorizing } = useContext(AuthorizationContext);

  return useCallback((requiredPermissions, requiredOneOfPermissions) => {

    const required = !requiredPermissions ? [] : (
      typeof requiredPermissions === "string"
        ? [ requiredPermissions ]
        : requiredPermissions
    );

    const requiredOneOf = !requiredOneOfPermissions ? [] : (
      typeof requiredOneOfPermissions === "string"
        ? [ requiredOneOfPermissions ]
        : requiredOneOfPermissions
    );

    const pending = ((!!required.length || !!requiredOneOf.length) && isAuthorizing);

    const isAccessAllowed = checkRequiredPermissions({
      existingPermissions: permissions,
      requiredPermissions: required,
      requiredOneOfPermissions: requiredOneOf,
      isSuperAdmin,
    });

    return ({
      pending,
      isAccessAllowed,
    });
  }, [ isSuperAdmin, permissions, isAuthorizing ]);
}


export function useCheckAccess(requiredPermissions?: string | string[], requiredOneOfPermissions?: string | string[]): {
  pending: boolean,
  isAccessAllowed: boolean
} {
  const checkAccessFunction = useGetCheckAccessFunction();

  return useMemo(
    () => checkAccessFunction(requiredPermissions, requiredOneOfPermissions),
    [ checkAccessFunction, requiredPermissions, requiredOneOfPermissions ],
  );
}
